// extracted by mini-css-extract-plugin
export default {"btnpwd":"_7f74a53a40"};